import { useEffect } from "react";

const useUnauthorizedObserver = (isAuthorized: boolean) => {
  useEffect(() => {
    if (!isAuthorized) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === "childList") {
            const backdropExists = document.getElementById("kairos-backdrop");
            if (!backdropExists) {
              // You can optionally trigger something here
            }
          }
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });

      return () => observer.disconnect();
    }
  }, [isAuthorized]);
};

export default useUnauthorizedObserver;
